var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value && _vm.value < 1000)?_c('div',[_vm._v("\n    "+_vm._s(_vm.value)+" Mbps\n  ")]):(_vm.value && _vm.value >= 1000)?_c('div',[_vm._v("\n    "+_vm._s(_vm.value/1000)+" Gbps\n  ")]):_c('div',[_vm._v("\n    N/A\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }